import { useTranslation } from "react-i18next"
import { Copy } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { useToast } from "@/hooks/useToast"

type BetterDocFieldProps = {
  label: string
  value: React.ReactNode
  testId: string
  copyText?: string
}

export const BetterDocField = ({ label, value, testId, copyText }: BetterDocFieldProps) => {
  const { t } = useTranslation()
  const { toast } = useToast()

  const handleCopy = () => {
    if (copyText === undefined) {
      return
    }

    navigator.clipboard.writeText(copyText)
    toast({ description: t("admin.betterDoc.copied") })
  }

  return (
    <div className="flex min-w-0 items-start justify-between gap-2" data-testid={testId}>
      <div className="flex min-w-0 flex-col">
        <span className="text-on-surface-subdued text-xs">{label}</span>
        <div className="text-on-surface text-sm wrap-break-word" data-testid={`${testId}-value`}>
          {value}
        </div>
      </div>
      {copyText === undefined ? null : (
        <Button
          type="button"
          variant="tertiary"
          className="p-2"
          aria-label={t("admin.betterDoc.copy")}
          onClick={handleCopy}
          data-testid={`${testId}-copy-button`}>
          <Copy className="size-4" />
        </Button>
      )}
    </div>
  )
}
